import { observer } from 'mobx-react';
import { useStore } from '../../../../store/store';
import { INVEST_PROFILE_FIELDS } from '../../../../utils/constants/fields';
import { formatNumber } from '../../../../utils/utils';
import { PUNCTUATION } from '../../../../utils/constants/notation';
import ChipsList from '../../../../components/common/ChipsList';

const InvestProfileGeneralInformation = observer(({ entry }) => {
  const { utilsStore } = useStore();

  return (
    <div className="content">
      {!!entry.companyName && (
        <div className="row">
          <div className="bullet"></div>
          <div className="label">Company name</div>
          <div className="value">{entry.companyName}</div>
        </div>
      )}
      <div className="row">
        <div className="bullet"></div>
        <div className="label">{INVEST_PROFILE_FIELDS.NAME.LABEL}</div>
        <div className="value">
          {entry[INVEST_PROFILE_FIELDS.NAME.NAME] || PUNCTUATION.EMPTY_VALUE}
        </div>
      </div>
      <div className="row">
        <div className="bullet"></div>
        <div className="label">{INVEST_PROFILE_FIELDS.REVENUE.LABEL} (€M)</div>
        <div className="value">{formatNumber(entry[INVEST_PROFILE_FIELDS.REVENUE.NAME])}</div>
      </div>
      <div className="row">
        <div className="bullet"></div>
        <div className="label">{INVEST_PROFILE_FIELDS.EBITDA.LABEL} (€M)</div>
        <div className="value">{formatNumber(entry[INVEST_PROFILE_FIELDS.EBITDA.NAME])}</div>
      </div>
      <div className="row">
        <div className="bullet"></div>
        <div className="label">{INVEST_PROFILE_FIELDS.DESCRIPTION.LABEL}</div>
        <div className="value">{entry[INVEST_PROFILE_FIELDS.DESCRIPTION.NAME]}</div>
      </div>
      <div className="row">
        <div className="bullet"></div>
        <div className="label">{INVEST_PROFILE_FIELDS.INDUSTRIES.LABEL}</div>
        <div className="value">
          {/* {utilsStore.getOptionName(entry, INVEST_PROFILE_FIELDS.INDUSTRIES).join(', ')} */}
          <ChipsList
            list={utilsStore.getOptionName(entry, INVEST_PROFILE_FIELDS.INDUSTRIES)}
            visibleCount={88888}
          />
        </div>
      </div>
      <div className="row">
        <div className="bullet"></div>
        <div className="label">{INVEST_PROFILE_FIELDS.GEOGRAPHIES.LABEL}</div>
        <div className="value">
          {/* {utilsStore.getOptionName(entry, INVEST_PROFILE_FIELDS.GEOGRAPHIES).join(', ')} */}
          <ChipsList
            list={utilsStore.getOptionName(entry, INVEST_PROFILE_FIELDS.GEOGRAPHIES)}
            visibleCount={88888}
          />
        </div>
      </div>
      <div className="row">
        <div className="bullet"></div>
        <div className="label">{INVEST_PROFILE_FIELDS.SITUATION.LABEL}</div>
        <div className="value">
          {/* {utilsStore.getOptionName(entry, INVEST_PROFILE_FIELDS.SITUATION).join(', ')} */}
          <ChipsList
            list={utilsStore.getOptionName(entry, INVEST_PROFILE_FIELDS.SITUATION)}
            visibleCount={88888}
          />
        </div>
      </div>
      <div className="row">
        <div className="bullet"></div>
        <div className="label">{INVEST_PROFILE_FIELDS.EQUITY.LABEL}</div>
        <div className="value">
          {/* {utilsStore.getOptionName(entry, INVEST_PROFILE_FIELDS.EQUITY).join(', ')} */}
          <ChipsList
            list={utilsStore.getOptionName(entry, INVEST_PROFILE_FIELDS.EQUITY)}
            visibleCount={88888}
          />
        </div>
      </div>
    </div>
  );
});

export default InvestProfileGeneralInformation;
